<script lang="ts" setup>
  import RewardSlider from "@/components/views/rewards/RewardSlider.vue";
  import { ref, nextTick } from "vue";
  import { useRewardsStore } from "@/stores/rewards";

  const props = withDefaults(defineProps<{
    showTitle?: boolean;
  }>(), {
    showTitle: true,
  });
  const rewardsStore = useRewardsStore();

  // Resize images that overflow the card
  function resizeLogo(event: Event) {
    const logo = event.target as HTMLImageElement;
    nextTick(() => {
      if (logo.clientHeight > 105) {
        logo.classList.add('reward-background-reduced');
      }
    });
  }
</script>

<template>
  <RewardSlider
    :title="props.showTitle ? $t('home.rewards.featured') : ''"
    class="rewards-featured-deals"
    :loading="!rewardsStore.getRewardsLoaded()"
  >
    <template #default>
      <v-slide-group-item
        v-for="(reward, n) in rewardsStore.getFeaturedRewards()"
        :key="reward.id"
      >
        <div class="reward-item" @click="rewardsStore.openRewardModal(reward, 'Featured offers')">
          <v-card
            class="reward-card"
            width="155"
            height="87"
          >
            <img class="reward-background" :src="reward.logo" @load="resizeLogo" draggable="false"/>
          </v-card>
          <div class="reward-description t-bold t-body-2">
            {{ reward.nameShort }}
          </div>
        </div>
      </v-slide-group-item>
    </template>
    <template #skeleton>
      <v-slide-group-item
        v-for="n in 10"
        :key="n"
      >
        <v-skeleton-loader
          type="card, text"
          class="card-skeleton"
        ></v-skeleton-loader>
      </v-slide-group-item>
    </template>
  </RewardSlider>
</template>

<style lang="scss" scoped>
  .rewards-featured-deals {
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
  }

  .reward-item {
    position: relative;
    max-width: 155px;

    .reward-card {
      background-color: transparent;
      margin-bottom: 9px;
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.07);
      border-radius: $globalBorderRadius;

      .reward-background {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100%;
        transform: translateX(-50%) translateY(-50%);
        z-index: 0;
        transition: 0.5s ease width;
      }

      .reward-background-reduced {
        transition: 0.5s ease width;
        width: 50%;
      }

      .v-card__overlay {
        background-color: transparent;
      }
    }

    .reward-card:hover {
      .reward-background {
        width: 110%;
      }

      .reward-background-reduced {
        width: 60%;
      }
    }

    .reward-description {
      padding: 0 18px;
      color: rgb(var(--v-theme-primary));
      text-transform: capitalize;
      text-align: center;
    }
  }

  .reward-item:hover {
    cursor: pointer;
  }

  .card-skeleton {
    margin-right: 12px;

    :deep(.v-skeleton-loader__bone.v-skeleton-loader__card) {
      width: 126px;
      height: 82px;
      margin-bottom: 0;
    }

    :deep(.v-skeleton-loader__bone.v-skeleton-loader__text) {
      width: 100%;
      height: 20px;
      margin-top: 6px;
    }
  }
</style>